import { RechargeHuiTianFu } from "./huitianfu/huitianfu";
import { RechargeIFee } from "./ifee/ifee";
import { Payment } from "./payment";
import { RechargeJiFu } from "./jifu/jifu";
import { RechargeHuiBoWY } from "./huibowy/huibowy";
import { RechargeMiaoKaTong } from "./miaokatong/miaokatong";
import { RechargeHeBao } from "./hebao/hebao";
import { Component } from "@angular/core";
import { NavController, App, PopoverController } from "ionic-angular";
import { RechargeService } from "../../services/recharge.service";
import { RechargeMain } from "./rechargemain";
import { AlertService } from "../../providers/alert.service";
import { AppConfig } from "../../app/app.config";
import { Clipboard } from "clipboard/dist/clipboard.min.js";
import { SigninPage } from "../signin/signin";
import { RechargeWx } from "./rechargewx";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { LoaddingService } from "../../providers/loadding.service";
import { ExchangeRateDto, RechardUSDTInput } from "../../models/transferRecord.model";
import { FixedExtend } from "../../config/fixed-extend";
import { DaikeModalPage } from "../daike-modal/daike-modal";
import { UserBankService } from "../../services/userbank.service";
import { PageDefault } from "../PageDefault";
import { UserBankList } from "../userbanks/userbanklist";

/*
  充值
*/
@Component({
  selector: "page-recharge",
  templateUrl: "recharge.html",
  providers: [RechargeService, UserBankService],
})
export class RechargePage {
  banks = [];
  curruser; //this.config.getCurrentUser();
  money = ""; //充值金额
  moneyList = [];
  // value = this.moneyList[0];
  bankId = "";
  bankcode = "";
  minmoney = 0;
  maxmoney = 0;
  banknum = "";
  Fee;
  commt = "";
  bankusername = "";
  addtime = "";
  aliusername = ""; //支付宝账户名
  currstep = 1;
  currentBank = {
    BankUrl: "",
    ChargeUrl: ''
  };
  result = {};
  flagCheckeds = 0;
  isHaves: boolean;
  realname = "";
  pcFlag: boolean = false;
  component: Payment = null;
  param;
  bankUrlArr = [];
  bankUrl: any;
  //所有银行线下充值 start
  firststep: boolean = true;
  secondstep: boolean = false;
  icbcname: string = "";
  icbcmoney: number = 0;
  parameter: number;

  // 当前汇率
  displayString: string = "";
  exchangeRate;
  // USDT个数
  usdtCount: string = "";
  // 转账钱包
  transferAccount: string;
  // 转账哈希
  usdtTransactionId: string;
  usdtInput: RechardUSDTInput = new RechardUSDTInput();
  daikeParams;
  // end
  payments = [
    new Payment(RechargeMain, [""], "01", true),
    new Payment(RechargeHuiBoWY, ["Huixin"], "01", true),
    new Payment(RechargeHeBao, ["HeBao"], "01", true),
    new Payment(RechargeJiFu, ["JiFu"], "01", true),
    new Payment(RechargeHuiBoWY, ["HuiboWY"], "01", true),
    new Payment(RechargeIFee, ["IFee"], "01", true),
    new Payment(RechargeHuiTianFu, ["HuiTianFu"], "01", true),
    new Payment(
      RechargeMiaoKaTong,
      [
        "MiaoKaTong",
        "SuHuiBao",
        "HuiTeng",
        "MoreDeBao",
        "Guangshun",
        "Huitfwy",
      ],
      "01",
      true
    ),
  ];

  haveCard = true;

  constructor(
    private rechargeSerice: RechargeService,
    private navCtrl: NavController,
    private alert: AlertService,
    private config: AppConfig,
    private appCtrl: App,
    private iab: InAppBrowser,
    private loadding: LoaddingService,
    private fixedExtend: FixedExtend,
    private popCtrl: PopoverController,
    public userBankService: UserBankService,
  ) {
    this.curruser = this.config.getCurrentUser();
    this.getBanks();
    this.getUsdtSetting();

    this.userBankService
      .getUserBanks(PageDefault.PageIndex(), PageDefault.PageSize())
      .then((s) => {
        if (!s || s.length == 0) {
          this.haveCard = false;
        }
      });
  }

  goBank() {
    this.navCtrl.push(UserBankList);
  }

  ngOnInit() { }

  ///---查询思路
  /// 1、先找BankCode包含当前BankCode的
  /// 2、再找BankType且是默认的
  getComponent() {
    let paymentlst = this.payments;
    let findpayment = paymentlst.find(
      (s) => s.bankCodes.indexOf(this.currentBank["BankCode"]) > -1
    );
    if (findpayment) {
      return findpayment;
    }
    findpayment = paymentlst.find(
      (s) =>
        s.bankType == (this.currentBank["IsChargeUrl"] ? "01" : "02") &&
        s.isDefault
    );
    if (findpayment) {
      return findpayment;
    } else {
      return paymentlst.find((s) => s.isDefault);
    }
  }

  //获取所有充值方式
  //TQQ 2017-01-04
  async getBanks() {
    this.rechargeSerice.getBanks().then((s) => {
      let count = 1,
        leng = s.length;
      this.bankUrl = s;
      this.bankUrl.forEach((s, i) => {
        count++;
        // s.Limit.supportPlatform == "1" 仅web显示
        //                             2  仅手机端显示
        //                             0  web和手机都显示
        if (
          s.Limit &&
          s.Limit.supportPlatform &&
          s.Limit.supportPlatform == "1"
        ) {
          this.bankUrlArr.push(i);
        }
        if (count == leng) {
          let count = 0;
          this.bankUrlArr.forEach((i) => {
            count++;
            if (count == 1) {
              this.bankUrl.splice(i, 1);
            } else {
              this.bankUrl.splice(i - 1, 1);
            }
          });
        }
      });
      s = this.bankUrl;
      if (s && s.length > 0) {
        this.banks = s;

        this.banks.forEach((ele, k) => {
          ele['tipsName'] = ele.SysBankName;
          if (ele.Limit.givePercent > 0) {
            ele['tipsName'] = ele.SysBankName + ' *送' + (ele.Limit.givePercent * 100) + '%';
          }
          if (ele.Limit.dayGivePercent > 0) {
            ele['tipsName'] = ele.SysBankName + ' *首充送' + (ele.Limit.dayGivePercent * 100) + '%';
          }
        });

        this.bankId = s[0].ID;
        this.minmoney = s[0].MinChargeMoney;
        this.maxmoney = s[0].MaxChargeMoney;
        this.bankcode = s[0].BankCode;
        this.banknum = s[0].BankNum;
        this.Fee = s[0].Fee * 100;
        this.commt = s[0].Commt;
        this.bankusername = s[0].BankUserName;
        this.currentBank = this.banks[0];
        // console.log("$$$$$$$$$$$$$$", this.currentBank);
        if (
          s[0].Limit &&
          s[0].Limit.supportPlatform &&
          s[0].Limit.supportPlatform == 1
        ) {
          this.pcFlag = true;
        } else {
          this.pcFlag = false;
        }
        if (s[0].Limit && s[0].Limit.fixedMoney) {
          this.moneyList = s[0].Limit.fixedMoney;
          this.isHaves = true;
        } else {
          this.moneyList = null;
          this.isHaves = false;
        }
        this.component = this.getComponent();
      }
    });
  }

  //充值方式更改事件
  //TQQ 2017-01-04
  selectClick() {
    let currbank = this.banks.find((s) => s.ID == this.bankId);
    this.currentBank = currbank;
    this.minmoney = currbank.MinChargeMoney;
    this.maxmoney = currbank.MaxChargeMoney;
    this.bankcode = currbank.BankCode;
    this.banknum = currbank.BankNum;
    this.bankusername = currbank.BankUserName;
    this.Fee = currbank.Fee * 100;
    this.commt = currbank.Commt;
    if (
      currbank.Limit &&
      currbank.Limit.supportPlatform &&
      currbank.Limit.supportPlatform == 1
    ) {
      this.pcFlag = true;
    } else {
      this.pcFlag = false;
    }
    if (currbank.Limit && currbank.Limit.fixedMoney) {
      this.moneyList = currbank.Limit.fixedMoney.split(",");
    } else {
      this.moneyList = null;
    }
    if (this.moneyList == null || this.moneyList.length < 1) {
      this.isHaves = false;
    } else {
      this.isHaves = true;
    }
    this.component = this.getComponent();
  }
  // 所有银行线下充值
  icbcNext(u, m, min, max) {
    if (m < min) {
      this.alert.showAlert(`最低充值金额不得小于${min}元!`);
      return;
    } else if (m > max) {
      this.alert.showAlert(`充值金额上限为${max}元!`);
      return;
    } else {
      if (u && m) {
        let code = "NEWCODE";
        this.icbcname = u;
        this.icbcmoney = m;
        this.firststep = false;
        this.secondstep = true;
        let param = {
          Amount: this.icbcmoney,
          BankId: this.bankId,
          // bankcode: code,
          Realname: this.icbcname,
        };
        this.rechargeSerice.getOrder(param).then((s) => {
          this.parameter = s.Parameter;
        });
      }
    }
  }
  //支付宝人工(高速支付)
  //2017-01-04
  newPushOrder() {
    let code = "NEWCODE";
    let param = {
      // amount: this.icbcmoney,
      // bankcode: code,
      // realname: this.icbcname,
      RecordCode: this.parameter,
    };
    this.rechargeSerice.pushOrder(param).then((s) => {
      this.alert.showAlert(s.Error);
    });
  }
  previous() {
    this.firststep = true;
    this.secondstep = false;
  }
  moneychange() {
    let Reg = /^[0-9]+(.[0-9]{1,3})?$/;
    let isNum = Reg.test(this.money);
    if (!isNum) {
      this.alert.showAlert("转账金额只能为大于零的数字或小数");
    }
  }
  //下一步点击事件
  //TQQ 2017-01-04
  nextClick() {
    let currbank = this.banks.find((s) => s.ID == this.bankId);
    if (!this.money) {
      this.alert.showAlert("请输入正确的充值金额");
      return;
    }
    if (
      currbank.MinChargeMoney > this.money ||
      this.money > currbank.MaxChargeMoney
    ) {
      this.alert.showAlert(
        "充值限额：最低" +
        currbank.MinChargeMoney +
        "， 最高" +
        currbank.MaxChargeMoney
      );
      return;
    }
    const loadding = this.loadding.showLoding("");
    this.rechargeSerice
      .recharge(this.curruser.UserName, parseFloat(this.money), currbank.ID)
      .then((s) => {
        this.loadding.closeLoading(loadding);
        let param = {
          ChargeMoney: this.money,
          RecordCode: s.RecordCode,
          BankCode: currbank.BankCode,
          RecodeID: s.ID,
          AddTime: s.AddTime,
          ChargeUrl: currbank.ChargeUrl,
          SysBankName: currbank.SysBankName,
          limit: currbank.Limit,
        };
        this.navCtrl.push(this.component.component, param);
      })
      .catch((err) => {
        this.loadding.closeLoading(loadding);
      });
  }

  rechargeClick(item) {
    this.navCtrl.push(RechargeMain);
  }

  //支付宝人工(高速支付)
  //TQQ 2017-01-04
  zfbrgClick() {
    // let data = new Date();
    // let hou = data.getHours();
    // let min = data.getMinutes();
    // this.addtime = hou + "点" + min + "分";
    // if (!this.money) {
    //   this.alert.showAlert('请输入正确的充值金额');
    //   return;
    // }
    let param =
      "amount=" +
      this.money +
      "&bankid=" +
      this.bankId +
      "&realname=" +
      this.realname;
    this.rechargeSerice.zfbrgRecharge(param).then((s) => {
      this.alert.showAlert(s.Error);
    });
  }
  jinge(s) {
    // this.money=moneyList
    this.flagCheckeds = s;
    this.money = s;
  }

  //支付宝自动
  //TQQ 2017-01-04
  zfbzdClick() {
    if (!this.money) {
      this.alert.showAlert("请输入正确的充值金额");
      return;
    }
    if (!this.aliusername) {
      this.alert.showAlert("请输入支付宝户名");
      return;
    }
    this.rechargeSerice
      .zfbzdRecharge(parseFloat(this.money), this.aliusername, this.bankId)
      .then((s) => {
        // if (s == null) {
        //   this.alert.showAlert('充值失败，请联系客服');
        // }
        this.result = s;
        this.currstep = 2;
      })
      .catch((s) => {
        if (s != null) {
          this.alert.showAlert(s.ExceptionMessage);
        }
      });
  }

  wxnext() {
    let currbank = this.banks.find((s) => s.ID == this.bankId);
    if (!this.money) {
      this.alert.showAlert("请输入正确的充值金额");
      return;
    }
    if (
      currbank.MinChargeMoney > this.money ||
      this.money > currbank.MaxChargeMoney
    ) {
      this.alert.showAlert(
        "充值限额：最低" +
        currbank.MinChargeMoney +
        "， 最高" +
        currbank.MaxChargeMoney
      );
      return;
    }
    this.rechargeSerice
      .recharge(this.curruser.UserName, parseFloat(this.money), currbank.ID)
      .then((s) => {
        this.param = {
          Commt: currbank.Commt,
          BankImg: currbank.BankImg,
          BankImgHead: currbank.BankImgHead,
          ChargeMoney: s.ChargeMoney,
          RecordCode: s.RecordCode,
          BankCode: currbank.BankCode,
          RecodeID: s.ID,
          AddTime: s.AddTime,
          ChargeUrl: currbank.ChargeUrl,
          banknum: this.banknum,
          bankusername: this.bankusername,
          limitType: currbank.Limit.type,
          SysBankName: currbank.SysBankName,
        };
        this.navCtrl.push(RechargeWx, { param: this.param });
      })
      .catch((c) => {
        if (c.status === 401 || c.status === 403) {
          this.alert.showAlert("验证已失效，您需要退出重新登录!");
          localStorage.clear();
          this.appCtrl.getRootNav().setRoot(SigninPage);
        }
      });
  }
  //联系客服
  //TQQ 2017-03-03
  openKefu() {
    let connect = this.config.getSysConfig();
    this.config.openUrl(connect.CustomerServiceUrl);
  }

  //复制
  //TQQ 2017-03-13
  copyLink(link, $event) {
    var that = this;
    var clipboard = new Clipboard(".btn_copy");
    var linkb = link;
    $event.currentTarget.attributes[1].nodeValue = linkb;
    clipboard.on("success", function (e) {
      that.alert.showAlert("复制" + link + "成功！");
      e.clearSelection();
    });
  }

  goAliPlay() {
    this.alert.showConfirm("新窗口打开链接？", () => {
      this.config.openUrl(this.currentBank.BankUrl);
    });
  }

  getUsdtSetting() {
    this.rechargeSerice.getUsdtSetting().then((result: ExchangeRateDto) => {
      if (result) {
        this.exchangeRate = result;
        this.displayString = `1USDT=${this.exchangeRate.Parameter2.ExchangeRateUp}CNY`;
      }
    });
  }

  usdtValueChange() {
    // const _value = parseFloat(this.usdtCount) * this.exchangeRate.Parameter2.ExchangeRateUp;
    const _value = this.fixedExtend.accMul(this.usdtCount, this.exchangeRate.Parameter2.ExchangeRateUp);
    this.money = _value.toString();
  }

  rechargeValueChange() {
    if (isNaN(parseFloat(this.money))) {
      this.alert.showAlert("输入数据类型错误，请输入数字类型数据");
      return;
    }
    if (this.exchangeRate && this.money && this.exchangeRate.Parameter2.ExchangeRateUp) {
      // let _value = parseFloat(this.money) / this.exchangeRate.ExchangeRateUp;
      let _value = this.fixedExtend.accDiv(this.money, this.exchangeRate.Parameter2.ExchangeRateUp)
      this.usdtCount = _value.toString()
        .substr(0, _value.toString().indexOf(".") + 3);
    }
  }

  usdtNext(minMoney, maxMoney) {
    this.usdtInput.Bankid = this.currentBank["ID"];
    this.usdtInput.Amount = parseFloat(this.money);
    this.usdtInput.Usdtamount = parseFloat(this.usdtCount);
    this.usdtInput.ExchangeRate = this.exchangeRate.Parameter2.ExchangeRateUp;
    this.usdtInput.Realname = this.transferAccount;
    this.usdtInput.Transactionid = this.usdtTransactionId;
    this.usdtInput.Commt = "";

    if (isNaN(this.usdtInput.Usdtamount)) {
      this.alert.showAlert(`请输入您需要转账的USDT个数!`);
      return;
    }

    if (isNaN(this.usdtInput.Amount)) {
      this.alert.showAlert(`请输入您需要转账的金额!`);
      return;
    }

    if (this.usdtInput.Amount < minMoney) {
      this.alert.showAlert(`最低充值金额不得小于${minMoney}元!`);
      return;
    } else if (this.usdtInput.Amount > maxMoney) {
      this.alert.showAlert(`充值金额上限为${maxMoney}元!`);
      return;
    }

    if (
      !this.usdtInput.Realname ||
      this.usdtInput.Realname.toString().length < 20
    ) {
      this.alert.showAlert("请确认钱包地址是否正确！");
      return;
    }

    if (this.bankcode == 'USDT') {
      if (
        !this.usdtInput.Realname ||
        this.usdtInput.Realname.toString().substring(0, 2) !== "0x"
      ) {
        this.alert.showAlert("USDT-ERC20钱包必须以0x开头");
        return;
      }
    }
    if (this.bankcode == 'USDT-TRC20') {
      if (
        !this.usdtInput.Realname ||
        this.usdtInput.Realname.toString().substring(0, 1) !== "T"
      ) {
        this.alert.showAlert("USDT-TRC20钱包必须以T开头");
        return;
      }
    }

    if (
      !this.usdtInput.Transactionid ||
      this.usdtInput.Transactionid.toString().length < 40
    ) {
      this.alert.showAlert("请确认转账哈希(Transaction Hash)是否正确！");
      return;
    }

    if (this.bankcode.includes('USDT')) {
      this.rechargeSerice
        .addUsdtRechard(this.usdtInput)
        .then((s) => {
          if (s.Result) {
            this.usdtTransactionId = '';
            this.transferAccount = '';
            this.money = null;
            this.usdtCount = null;
            this.alert.showAlert(s.Error);
          } else {
            this.alert.showAlert(s.Error);
          }
        })
        .catch(() => { });
    } else {
      this.secondstep = true;
      this.firststep = false;
    }
  }

  skipMobile() {
    this.alert.showConfirm("新窗口打开链接？", () => {
      this.config.openUrl(this.exchangeRate.Parameter2.CoursePC && this.exchangeRate.Parameter2.CoursePC != 'null' ?
        this.exchangeRate.Parameter2.CoursePC : this.exchangeRate.Parameter2.CourseMobile);
    });
  }

  /**
   * 代客充值按钮
   */
  daikeBtn() {
    let modal = this.popCtrl.create(DaikeModalPage, { url: this.currentBank.ChargeUrl }, { cssClass: "daike-moal" })
    modal.present();
  }

  /**
   *  人工客服
   */
  async labourBtn() {
    this.config.openUrl(this.currentBank.ChargeUrl);
  }
}



// WEBPACK FOOTER //
// ./src/pages/recharge/recharge.ts